import React from 'react';
import { Card } from '~/components/Card';
import { StaticBasicInfo } from '.';

export function BasicInfo() {
    return (
        <Card
            title={
                <div className="row mb-0">
                    <div className="col-8 align-self-center">Basic Information</div>
                </div>
            }
        >
            <StaticBasicInfo />
        </Card>
    );
}
